export interface PPMAMCCounts {
  assets: {
    total: number;
    totalAMC: number;
    amcOverdue: number;
    amC3Months: number;
    ppmToday: number;
    ppmMonth: number;
    ppmOverdue: number;
  };
  totalDepartments: number;
  totalUsers: number;
  tickets: {
    total: number;
    open: number;
    assigned: number;
    inProgress: number;
    resolved: number;
    closed: number;
    reassigned: number;
    rejected: number;
  };
}
